export function findMinMaxValues<T extends object>(array: T[], keys: Array<keyof T>) {
	let min = 0;
	let max = 0;
	for (const item of array) {
		const values = Object.entries(item);
		for (const [key, value] of values) {
			if (!keys.includes(key as keyof T)) continue;
			if (typeof value !== "number") continue;
			if (value < min) min = value;
			if (value > max) max = value;
		}
	}
	return { min, max };
}
